import DropdownBtn from "components/shared/dropdown";
import { distributionBidInProcessModal } from "components/shared/distributionBidInProcessModal";
import InlineBtn from "components/shared/inlineBtn";
import { distributionBidStatusesEnum, syncEntityTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import React, { Component } from "react";
import { deleteItem, restore, revert } from "sources/books/distributionBids";
import CloneDistributionBid from "./cloneDistributionBid";
import DistributionBidFiles from "./distributionBidFiles";

export default class BidActions extends Component {
    get inlineActions() {
        const { history, id, data, roles, profile } = this.props;
        const { isRoot, isTruckingOrganizationAdmin } = roles;
        const { car } = data;
        return [
            {
                value: "Редактировать",
                cname: "edit",
                action: () => history.push(paths.distributionBidEdit(id)),
                show: !data.isDeleted && !data.bidId,
            },
            {
                value: "Создать заявку по заказу",
                cname: "checkmark",
                action: () => {
                    if (data.inProcessByUser && data.inProcessByUser?.id !== profile.id) {
                        this.props.modal(distributionBidInProcessModal({ userName: data.inProcessByUser.shortName }));
                    } else {
                        history.push(`${paths.bidNew}?distributionBidId=${id}${car ? `&carId=${car.carId}` : ""}`);
                    }
                },
                show:
                    data.status !== distributionBidStatusesEnum.Canceled &&
                    !data.isDeleted &&
                    !data.hasHiredCar &&
                    !data.bidId,
            },
            {
                value: "Вернуть в работу",
                cname: "undo",
                action: () => {
                    const { modal, getItem } = this.props;
                    return modal({
                        name: "confirm",
                        title: "Изменение заказа",
                        text: 'Вы уверены, что хотите вернуть заказ в статус "Без заявки"?',
                        buttons: { confirm: "Да", cancel: "Нет" },
                        action: () => revert({ id: data.id }).then(() => getItem()),
                    });
                },
                show: data.status === distributionBidStatusesEnum.Canceled && (isTruckingOrganizationAdmin || isRoot),
            },
            {
                value: "Создать копию заказа",
                action: () => {
                    const { modal, id } = this.props;
                    return modal({
                        name: "default",
                        title: "Копирование заказа",
                        CustomBody: CloneDistributionBid,
                        bodyData: { distributionBidId: id, setLoading: this.props.setLoading, history },
                    });
                },
                show: !data.isDeleted && data.bidId,
            },
            {
                value: "Восстановить",
                cname: "undo",
                action: () => {
                    const { modal, getItem } = this.props;
                    return modal({
                        name: "confirm",
                        title: "Восстановление заказа",
                        text: "Вы уверены, что хотите восстановить заказ?",
                        action: () => restore({ id: data.id }).then(() => getItem()),
                        buttons: { confirm: "Да", cancel: "Нет" },
                    });
                },
                show: data.isDeleted && (isTruckingOrganizationAdmin || isRoot),
            },
        ];
    }

    get dropDownActions() {
        const { bidPolicy, history, id, data } = this.props;
        if (data.isDeleted) {
            return [];
        }
        return [
            {
                text: "Изменить маршрут",
                action: () => history.push(`${paths.distributionBidEdit(id)}?editRoute=true`),
                show: true,
            },
            {
                text: "Удалить",
                action: () => {
                    const { modal } = this.props;
                    return modal({
                        name: "confirm",
                        title: "Удаление заказа",
                        text: "Вы уверены, что хотите удалить заказ?",
                        buttons: { confirm: "Да", cancel: "Нет" },
                        action: () => deleteItem(id),
                        onSuccessAction: () => history.push(paths.distributionBids),
                    });
                },
                show: !this.props.data.bidId,
            },
            {
                text: "Отменить",
                action: () => {
                    const { modal, getItem } = this.props;
                    return modal({
                        name: "distributionBidCancellation",
                        title: "Причина отмены заказа",
                        callback: () => getItem(),
                        id,
                    });
                },
                show: !this.props.data.bidId && this.props.data.status !== distributionBidStatusesEnum.Canceled,
            },
            {
                text: "Создать копию заказа",
                action: () => {
                    const { modal, id } = this.props;
                    return modal({
                        name: "default",
                        title: "Выберите условия копирования",
                        CustomBody: CloneDistributionBid,
                        bodyData: { distributionBidId: id, setLoading: this.props.setLoading, history },
                    });
                },
                show: !this.props.data.bidId,
            },
            {
                text: "Добавить статус синхронизации",
                action: () => {
                    const { modal, getItem, data } = this.props;
                    return modal({
                        name: "addSyncStatus",
                        title: "Добавление статуса синхронизации",
                        windowMod: "wide",
                        data: {
                            entityId: id,
                            externalId: data.externalId,
                            entityType: syncEntityTypesEnum.DistributionBid,
                        },
                        callback: (data) => data && getItem(),
                    });
                },
                show: bidPolicy.canSeeAddSyncStatusBtn(),
            },
            {
                text: "Файлы заказа",
                action: () => {
                    const { modal } = this.props;
                    return modal({
                        name: "default",
                        title: "Файлы заказа",
                        windowMod: "wide",
                        CustomBody: DistributionBidFiles,
                        bodyData: {
                            id: data.id,
                            canManageFiles:
                                data.status === distributionBidStatusesEnum.New && !data.bidId && !data.isDeleted,
                        },
                    });
                },
                show: true,
            },
        ];
    }

    render() {
        return (
            <div className="show-bid__actions">
                {this.inlineActions
                    .filter((x) => x.show)
                    .map((item, i) => (
                        <InlineBtn key={i} {...item} />
                    ))}
                {this.dropDownActions.find((x) => x.show) && (
                    <DropdownBtn text="Еще" items={this.dropDownActions.filter((x) => x.show)} />
                )}
            </div>
        );
    }
}
